import MicroModal from 'micromodal';

// Run the functions on document ready
document.addEventListener('DOMContentLoaded', () => {
    MicroModal.init();
});
